import React, { Component } from 'react';
import TextField from '@material-ui/core/TextField';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import { OverrideService } from '../../../logic/services';
import { AppIcon } from '../../../index';

const { main_color } = OverrideService.getThisOrOverridenColors();

const theme = createMuiTheme({
  // For Underline Color After Click
  palette: {
    primary: { main: main_color }
  },
  // For Underline Hover Color
  overrides: {
    MuiOutlinedInput: {
      notchedOutline: {
        borderColor: main_color,
        borderWidth: 1,
        borderRadius: 4
      },
      root: {
        color: 'rgba(0, 0, 0, 1)',
        '&$focused': {
          borderColor: main_color
        },
        '&:hover:not($disabled):not($focused):not($error) $notchedOutline': {
          borderColor: main_color
        }
      }
    },
    MuiFormLabel: {
      root: {
        color: main_color
      }
    }
  }
});

export default class InputField extends Component<any, any> {
  /**
   * Constructor
   *
   * @param props
   */
  constructor(props) {
    super(props);

    // Initial state
    this.state = {
      fieldType: this.props.type || 'text',
      showPassword: false
    };
  }

  componentDidMount() {
    this.setState({
      fieldType: this.props.type
    });
  }

  toggleShowPassword() {
    this.setState(
      {
        showPassword: !this.state.showPassword
      },
      () => {
        if (this.state.showPassword) {
          this.setState({
            fieldType: 'text'
          });
        } else {
          this.setState({
            fieldType: 'password'
          });
        }
      }
    );
  }

  /**
   * Get class name
   *
   * @returns {string}
   */
  getClassName() {
    const classNames = ['input-group'];
    if (this.props.fullWidth) {
      classNames.push('fulled');
    }

    return classNames.join(' ');
  }

  getValidationError() {
    const messages: any[] = [];

    if (this.props.handler) {
      this.props.handler
        .getErrors()
        .filter((x: { field: any }) => x.field === this.props.name)
        .forEach((error: { message: any }) => messages.push(error.message));
    }
    if (messages.length === 0) {
      return null;
    }
    return (
      <div className="validation-message" key={`${this.props.name}-error`}>
        {messages.join('<br/>')}
      </div>
    );
  }

  /**
   * Handle input change
   *
   * @param e
   */
  handleInputChange(e: any) {
    if (this.props.handler) {
      this.props.handler.handleInputChange(e);
    }
    if (this.props.onInputText) {
      this.props.onInputText(e.target.value, this.props.name);
    }
  }

  /**
   * Render input
   *
   * @returns {XML}
   */
  render() {
    // let className = this.getClassName();
    const validationError = this.getValidationError();

    return (
      <div
        className={this.props.className}
        style={{ position: 'relative' }}
        id={validationError ? 'outlined-error' : ''}
      >
        <MuiThemeProvider
          theme={this.props.muiTheme ? this.props.muiTheme : theme}
        >
          <TextField
            error={!!validationError}
            variant="outlined"
            autoComplete={this.props.autoComplete}
            label={this.props.label}
            className={this.props.className}
            type={this.state.fieldType}
            placeholder={this.props.placeholder}
            name={this.props.name}
            inputProps={this.props.inputProps}
            // margin="normal"
            // InputLabelProps={{
            //   shrink: true,
            // }}
            onFocus={this.props.onFocus}
            onBlur={this.props.onBlur}
            value={this.props.value}
            onChange={this.handleInputChange.bind(this)}
            {...this.props.materialProps}
          />
        </MuiThemeProvider>
        {this.props.type === 'password' && (
          <AppIcon
            onClick={() => this.toggleShowPassword()}
            name={!this.state.showPassword ? 'fa.eye' : 'fa.eye-slash'}
            style={{
              fontSize: 18,
              position: 'absolute',
              top: '35%',
              right: '10px',
              cursor: 'pointer'
            }}
          />
        )}

        {validationError}
      </div>
    );
  }
}
